import React from "react"
import { Button, IconButton, Dialog, DialogTitle, Slide, DialogContent, Grid, Paper, Typography, Divider } from "@mui/material"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableRow from "@mui/material/TableRow"
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown"
import CloseIcon from "@mui/icons-material/Close"

const getErrorText = (bookInLedger, isBundle) => {
  let errorText = ""

  const action = bookInLedger.action === "buy" ? "kaufen" : "verkaufen"
  const actionFinished = bookInLedger.action === "buy" ? "gekauft" : "verkauft"
  const bookText = isBundle ? "Bücherpaket" : "Buch"

  switch (bookInLedger.status) {
    case "search": {
      errorText = `Du möchtest dieses ${bookText} bereits ${action}. Ein Partner wird noch gesucht.`
      break
    }
    case "matched": {
      errorText = `Du möchtest dieses ${bookText} bereits ${action}. Ein Partner wurde schon gefunden.`
      break
    }
    case "finished": {
      errorText = `Du hast dieses ${bookText} bereits ${actionFinished}.`
      break
    }
    default: {
      errorText = "Fehler"
      break
    }
  }

  return errorText
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const BookDialog = ({ handleClose, book, buy, sell, isMobile, ledgerList }) => {
  const open = !!book
  if (!open) {
    return null
  }

  const { title, isbn, subject, grade, priceOriginal, publisher, comment, isBundle } = book

  const bookInLedger = ledgerList.find((e) => e.bookId === book.id)
  const blockActions = ["search", "matched", "finished"].includes(bookInLedger?.status)
  const errorText = blockActions ? getErrorText(bookInLedger, isBundle) : null

  return (
    <Dialog TransitionComponent={Transition} onClose={handleClose} open={open}>
      <DialogTitle>
        {title}
        <IconButton sx={{ position: "absolute", right: "1vw", top: "1vh" }} onClick={handleClose}>
          <CloseIcon color="secondary" />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          overflow: "auto",
        }}>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              {isMobile ? (
                <></>
              ) : (
                <TableRow>
                  <TableCell align="left">Titel</TableCell>
                  <TableCell align="right">{title}</TableCell>
                </TableRow>
              )}

              <TableRow>
                <TableCell align="left">Klasse</TableCell>
                <TableCell align="right">{grade}</TableCell>
              </TableRow>
              {!isBundle && (
                <>
                  <TableRow>
                    <TableCell align="left">Fach</TableCell>
                    <TableCell align="right">{subject}</TableCell>
                  </TableRow>
                  {/* eslint-disable-next-line */}
                  {!!isbn && isbn != 0 ? (
                    <TableRow>
                      <TableCell align="left">ISBN</TableCell>
                      <TableCell align="right">{isbn}</TableCell>
                    </TableRow>
                  ) : (
                    <></>
                  )}
                  {publisher ? (
                    <TableRow>
                      <TableCell align="left">Verlag</TableCell>
                      <TableCell align="right">{publisher}</TableCell>
                    </TableRow>
                  ) : (
                    <></>
                  )}
                  {priceOriginal ? (
                    <TableRow>
                      <TableCell align="left">Originalpreis</TableCell>
                      <TableCell align="right">{priceOriginal} €</TableCell>
                    </TableRow>
                  ) : (
                    <></>
                  )}
                </>
              )}
              <TableRow>
                <TableCell align="left">Endültiger Preis</TableCell>
                <TableCell align="right">Nach Absprache mit Partner</TableCell>
              </TableRow>
              {comment || isBundle ? (
                <TableRow>
                  <TableCell align="left">Information</TableCell>
                  <TableCell align="right">{isBundle ? `Alle Bücher der Klasse ${grade} zusammen.` : comment}</TableCell>
                </TableRow>
              ) : (
                <></>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {errorText ? (
          <Paper sx={{ width: "100%", mt: 2, py: isMobile ? 1 : 3, px: 1, backgroundColor: "#f8aaaa", border: "2px solid #f47f7f" }}>
            <Typography variant="body2">{errorText}</Typography>
          </Paper>
        ) : (
          <Grid container sx={{ width: "100%", mt: 2, height: "auto", display: isMobile ? "grid" : null }} spacing={2}>
            <Grid container item xs>
              <Grid item xs={12}>
                {grade >= 13 || grade === 0 ? (
                  <Typography align="center">Ich möchte {isBundle ? "alle Bücher" : "dieses Buch"} kaufen</Typography>
                ) : (
                  <Typography align="center">
                    Ich komme in die {grade}. Klasse und möchte {isBundle ? "alle Bücher" : "dieses Buch"} kaufen
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <KeyboardDoubleArrowDownIcon sx={{ align: "center", width: "100%" }} />
              </Grid>
              <Grid item xs={12}>
                <Button disabled={blockActions} onClick={buy} fullWidth variant="contained">
                  {/* <Button disabled={blockActions} onClick={buy} fullWidth variant="contained" startIcon={<Shop2Icon />}> */}
                  Kaufen
                </Button>
              </Grid>
            </Grid>
            {isMobile ? (
              <></>
            ) : (
              <Grid item xs={0.2}>
                <Divider orientation="vertical" />
              </Grid>
            )}

            <Grid container item xs>
              <Grid item xs={12}>
                {grade >= 13 || grade === 0 ? (
                  <Typography align="center">Ich möchte {isBundle ? "alle Bücher" : "dieses Buch"} verkaufen</Typography>
                ) : (
                  <Typography align="center">
                    Ich komme in die {grade + 1}. Klasse und möchte {isBundle ? "alle Bücher" : "dieses Buch"} verkaufen
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <KeyboardDoubleArrowDownIcon sx={{ align: "center", width: "100%" }} />
              </Grid>
              <Grid item xs={12}>
                <Button disabled={blockActions} onClick={sell} fullWidth variant="contained">
                  {/* <Button disabled={blockActions} onClick={sell} fullWidth variant="contained" endIcon={<SellIcon />}> */}
                  Verkaufen
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Divider sx={{ mt: "3vh" }} />

        <Typography sx={{ mt: "1vh", color: "gray" }} variant="caption">
          Es wird lediglich ein Partner gesucht und ein engültiger Kauf / Verkauf ist nicht garantiert.
          <br />
          Preis nach Absprache mit dem Partner.
        </Typography>
      </DialogContent>
    </Dialog>
  )
}

export default BookDialog
